import React, { Component } from 'react';
import Config from '../Config';
import Phone from './Phone';

class EmergencyCenters extends Component {
    state = {  } 

    componentDidMount() {
        // load data 
        this.url = Config.DigibonServiceBase + "emergencyCenters";

        fetch(this.url, Config.GetBearer())
          .then((res) => { return res.ok ? res.json() : { status: res.status } })
          .then((json) => {
            this.setState({ data:json});
          });

      }

    render() { 
        return (<div>
            <h4>Alarmcentrales</h4>

            {this.state.data&& this.state.data.map((item, index) => {
                return <div className="row" key={index}>
                        <div className="col">{item.code}</div>
                        <div className="col">{item.name} </div>
                        <div className="col"><a href={"mailto:" + item.emailRegister}>{item.emailRegister}</a></div>
                        <div className="col">{
                            item.phoneGeneral !==null && item.phoneGeneral !=="" && 
                            <Phone value={item.phoneGeneral}></Phone>
                        }</div>
                    </div>
            })
            }

        </div>);
    }
}

export default EmergencyCenters;